import { cn } from '@/lib/utils';
import LocalImage, { LocalImageProps } from '@/components/Common/LocalImage';
import { useMemo } from 'react';

interface PostImageProps extends LocalImageProps {
  rootClassName?: string;
}

const PostImage: React.FC<PostImageProps> = ({ rootClassName, ...props }) => {
  const computedLocalImageProps: LocalImageProps = useMemo(() => {
    return {
      imageStyle: {
        objectFit: 'contain',
        background: '#000',
      },
      ...props,
    };
  }, [props]);

  return (
    <div className={cn('h-full w-full', rootClassName)}>
      <LocalImage {...computedLocalImageProps} />
    </div>
  );
};

export default PostImage;
